let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("58oyr")).then(() => parcelRequire('aWUbc'));